import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { sessionStore } from "@/Globals/Stores/SessionStore";
import { BaseWorkflow } from "../BaseWorkflow/BaseWorkflow";
import { AcceptAgreementStep } from "./Steps/AcceptAgreementStep";
import { ChangeTempPasswordStep } from "./Steps/ChangeTempPasswordStep";
import { LoadCacheStep } from "./Steps/LoadCacheStep";
import { LoadTitlesAndSpecialtiesCacheStep } from "./Steps/LoadTitlesAndSpecialtiesCacheStep";
import { LoginMandatoryMultiFactorAuthenticationFlowStep } from "./Steps/MandatoryMultiFactorAuthenticationFlowStep";
import { RequiredRecoveryEmailFlowStep } from "./Steps/RequiredRecoveryEmailFlowStep";
import { UserTypeAssignmentStep } from "./Steps/UserTypeAssignmentStep";
import { LoginWorkflowStepEnum } from "./LoginWorkflowStepEnum";

class LoginWorkflow extends BaseWorkflow<LoginWorkflowStepEnum> {
    constructor() {
        super([
            new ChangeTempPasswordStep(),
            new LoadCacheStep(),
            new LoadTitlesAndSpecialtiesCacheStep(),
            new RequiredRecoveryEmailFlowStep(),
            new LoginMandatoryMultiFactorAuthenticationFlowStep(),
            new AcceptAgreementStep(),
            new UserTypeAssignmentStep()

        ]);
        this.startWorkflow();
    }

    // redirect to myle
    protected onCompletedWorkflow(): void {
        if (navStore.lastUnauthorizedPath)
            RouterHistory.push(navStore.lastUnauthorizedPath);
        else {
            RouterHistory.push(sessionStore.isAuthenticated() && !sessionStore.isSignInRequired() && sessionStore.hasPermission(EnumMyleLoginPermission.CalendarTabPermission)
                ? "calendar"
                : "myle"
            );
        }
    }
}

export { LoginWorkflow };
